function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-groupeElectro");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-groupeElectro"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(4.000000, 16.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 10,
  height: 6
})), /*#__PURE__*/React.createElement("path", {
  d: "M4,5 L4,8 L26,8 L26,5 L27,5 L27.0005166,17.7581204 C26.2853652,17.2792703 25.4252961,17 24.5,17 C22.0147186,17 20,19.0147186 20,21.5 C20,22.0263612 20.0903714,22.531615 20.2564447,23.0010919 L4,23 L4,25 L3,25 L3,5 L4,5 Z M24.5,18 C26.4329966,18 28,19.5670034 28,21.5 C28,23.4329966 26.4329966,25 24.5,25 C22.5670034,25 21,23.4329966 21,21.5 C21,19.5670034 22.5670034,18 24.5,18 Z M6.5,18 C5.67157288,18 5,18.6715729 5,19.5 C5,20.3284271 5.67157288,21 6.5,21 C7.32842712,21 8,20.3284271 8,19.5 C8,18.6715729 7.32842712,18 6.5,18 Z M11.5,18 C10.6715729,18 10,18.6715729 10,19.5 C10,20.3284271 10.6715729,21 11.5,21 C12.3284271,21 13,20.3284271 13,19.5 C13,18.6715729 12.3284271,18 11.5,18 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30GroupeElectro = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30GroupeElectro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-groupeElectro.78670095.svg";
export { ForwardRef as ReactComponent };